// src/locales/en/orders.js
export const orders = {
    newOrder: "නව ඇණවුම",
    orderNumber: "ඇණවුම #{{number}}",
    customer: "ගනුදෙනුකරු",
    amount: "මුදල",
    date: "දිනය",
    status: "තත්ත්වය",
    pending: "පැවැත්වෙන",
    processing: "සැකසෙමින්",
    shipped: "යවා ඇත",
    delivered: "ලබා දී ඇත",
    cancelled: "අවලංගු කරන ලදී",
    returned: "ආපසු ලබා දී ඇත"
}